// extracted by mini-css-extract-plugin
module.exports = {"noCard":"CreateTemplate_noCard__4-7Nt","idWrapper":"CreateTemplate_idWrapper__r6pN3","layoutPropertiesWrapper":"CreateTemplate_layoutPropertiesWrapper__1-2+7"};